import { useState } from "react";

import { useDarkMode } from "../../context/DarkModeContext";
import { settingsData } from "../../assets/DemoData";
import {
  InternalContainer,
  ExternalContainer,
} from "../../components/Reusable/Layout";
import {
  UserDetailModal,
  CreateAdminModal,
} from "../AdminManagement/component";
import { SettingsTable, SettingsSearchFilter } from "./component";
import { AddMarchantModal } from "./component";

const Settings = () => {
  const darkMode = useDarkMode();
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const [isCreateMerchantModalOpen, setIsCreateMerchantModalOpen] =
    useState(false);

  const handleUserClick = (user: any) => {
    setSelectedUser(user);
    setIsDetailsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsDetailsModalOpen(false);
  };
  const handleCreateMerchantClick = () => {
    setIsCreateMerchantModalOpen(true);
  };
  const handleCloseCreateMerchantModal = () => {
    setIsCreateMerchantModalOpen(false);
  };

  const handleUserOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      setIsDetailsModalOpen(false);
    }
  };

  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <ExternalContainer>
      <div className="h-screen w-[1030px]">
        <InternalContainer headerText="Admin Management">
          <div className="flex flex-col">
            <SettingsSearchFilter onClick={handleCreateMerchantClick} />
            <div className="border border-[#FFFFFF1A]">
              <SettingsTable
                settingsData={settingsData}
                onUserClick={handleUserClick}
              />
            </div>
          </div>
        </InternalContainer>
      </div>
      <AddMarchantModal
        isOpen={isCreateMerchantModalOpen}
        onClose={handleCloseCreateMerchantModal}
        handleOverlayClick={handleUserOverlayClick}
        handleModalClick={handleModalClick}
      />
    </ExternalContainer>
  );
};

export default Settings;
